import { DEFAULT_ASSIGNMENT_RESTRICTION } from '@/components/Form/components/AssignmentRestriction/consts';
import { adaptFilterGroupInput } from '@/components/Form/components/Conditions/utils';
import {
  ContentCollectionGroupType,
  GroupTypeEnum,
  UserCollectionGroupType,
  VisibilitySettingsType,
} from '@/types/schema';

import { CreateUserGroupInput, GroupEditorProps } from '../types';

const getInitialValues = (
  defaultContentVisibilitySettings: VisibilitySettingsType | null,
  type: GroupTypeEnum,
  enableAssignmentRestriction: boolean,
): CreateUserGroupInput => {
  return {
    name: '',
    description: '',
    contentVisibilitySettings: defaultContentVisibilitySettings,
    assignmentRestriction:
      type === GroupTypeEnum.ContentCollection && enableAssignmentRestriction
        ? DEFAULT_ASSIGNMENT_RESTRICTION
        : undefined,
  };
};

type Params = {
  defaultContentVisibilitySettings: VisibilitySettingsType | null;
  group?: UserCollectionGroupType | ContentCollectionGroupType;
  enableAssignmentRestriction: boolean;
} & Pick<GroupEditorProps, 'type'>;

export const getInitialFormValues = ({
  defaultContentVisibilitySettings,
  group,
  type,
  enableAssignmentRestriction,
}: Params): CreateUserGroupInput => {
  if (!group) {
    return getInitialValues(defaultContentVisibilitySettings, type, enableAssignmentRestriction);
  }

  return {
    name: group.name,
    description: group.description,
    filterGroup: adaptFilterGroupInput(group.filterGroup),
    contentVisibilitySettings:
      (group as ContentCollectionGroupType).contentVisibilitySettings ||
      defaultContentVisibilitySettings,
    assignmentRestriction:
      type === GroupTypeEnum.ContentCollection && enableAssignmentRestriction
        ? (group as ContentCollectionGroupType).assignmentRestriction ||
          DEFAULT_ASSIGNMENT_RESTRICTION
        : undefined,
  };
};

export const GROUP_EDITOR_TRANSLATIONS = {
  [GroupTypeEnum.UserCollection]: {
    title: 'Group:Editor.NewGroup',
    editTitle: 'Group:Editor.EditGroup',
    description: 'Group:Editor.NewGroupDescription',
  },
  [GroupTypeEnum.ContentCollection]: {
    title: 'Group:Editor.NewCollection',
    editTitle: 'Group:Editor.EditCollection',
    description: 'Group:Editor.NewCollectionDescription',
  },
};
